module.exports = __webpack_public_path__ + "static/media/coin_usdt.d4dd23a4.png";